export class SignalrNotificationConstant
{
    public static SEPERATOR= ['>', '+'];
    public static NOTIFICATIONSCOPE={
        BROADCAST:1,
        USER:2,
        FILTER:3
    };
}

export interface ISubscriptionFilter {
    Context: string;
    ActionName: string;
    Value: string;
}